import React from "react";
import styled from "styled-components";

import type { Goal } from "../types/Goal";
import SYProgressBar from "./SYProgressBar";
import {
  CSS_BREAKPOINTS_MIN,
  GUTTER_SIZE,
  PAPER_WHITE_COLOR,
  SPACING_BASE,
  WHITE_COLOR,
} from "../config/constants";
import CardHead from "./CardHead";
import SYBody16pt from "./SYBody16pt";
import SYHeadlineFive from "./SYHeadlineFive";
import { themeSkillYoga } from "../styles/themeSkillYoga";

const RowInformationContainer = styled(CardHead)`
  margin: 0;
  padding: 0;

  ${(props) =>
    !props.divider &&
    `border-bottom: 0;
    box-shadow: none;`}
`;

const RowInformationWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  margin: ${themeSkillYoga.getGutterSpacing()} 0 0;
`;

const GoalCardProp = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
`;

const LandingPageCardProp = styled.div`
  flex: 1;
`;

const Headline = styled.div`
  font-family: Poppins-Light, sans-serif;
  font-size: 15px;
  line-height: 26px;
  text-transform: uppercase;
  margin: 0 0 ${GUTTER_SIZE / 2}px;
  color: #7b848d;

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    font-size: 16px;
    line-height: 26px;
  }
`;

const ExperienceLabel = styled(SYBody16pt)`
  font-family: "Poppins", sans-serif;
  color: ${PAPER_WHITE_COLOR};
  font-weight: 500;
`;

const RowInformation = React.memo(({ suitableFor, lengthClass, timeFrame }) => {
  const CardProp = ({ children }) =>
    timeFrame ? (
      <LandingPageCardProp>{children}</LandingPageCardProp>
    ) : (
      <GoalCardProp>{children}</GoalCardProp>
    );
  return (
    <>
      <RowInformationWrapper>
        {!!suitableFor && (
          <CardProp>
            <Headline>Suitable for</Headline>
            <ExperienceLabel color={PAPER_WHITE_COLOR}>
              {suitableFor}
            </ExperienceLabel>
          </CardProp>
        )}

        {!!lengthClass && (
          <CardProp>
            <Headline>Length</Headline>
            <ExperienceLabel color={PAPER_WHITE_COLOR}>
              {lengthClass}
            </ExperienceLabel>
          </CardProp>
        )}

        {!!timeFrame && (
          <CardProp>
            <Headline>Timeframe</Headline>
            <ExperienceLabel color={PAPER_WHITE_COLOR}>
              {timeFrame}
            </ExperienceLabel>
          </CardProp>
        )}
      </RowInformationWrapper>
    </>
  );
});

export default RowInformation;
